export function mapPropertyFormsToCreateRequest(basicInformation: any, address: any, photos: { url: string }[], homeowner: any, updatingProperty: boolean) {
    let request: any = {
        organization_id: basicInformation.organization_id,
        address: {
            country_id: address.country_id != -1 ? Number(address.country_id) : null,
            country_name: address.country_name,
            status_id: 3,
            state: address.state,
            address_line_1: address.address_line_1,
            address_line_2: address.address_line_2,
            city: address.city,
            postal_code: address.postal_code
        },
        property_owner_address: {
            country_id: homeowner.country_id != -1 ? Number(homeowner.country_id) : null,
            country_name: homeowner.country_name,
            status_id: 3,
            state: homeowner.state,
            address_line_1: homeowner.address_line_1,
            address_line_2: homeowner.address_line_2,
            city: homeowner.city,
            postal_code: homeowner.postal_code
        },
        photos: photos.map(p => ({ url: p.url })),
        property_name: basicInformation.property_name,
        property_type_id: basicInformation.property_type,
        accommodates: String(basicInformation.accommodates),
        bathrooms: String(basicInformation.bathrooms),
        bedrooms: String(basicInformation.bedrooms),
        description: basicInformation.description,
        property_owner_name: homeowner.property_owner_name,
        property_owner_email: homeowner.property_owner_email,
        property_owner_phone: homeowner.property_owner_phone
    };

    if(basicInformation.property_reference_id) {
        if(updatingProperty) {
            request.reference_id = basicInformation.property_reference_id;
        } else {
            request.property_reference_id = basicInformation.property_reference_id;
        }
    }

    if(address.address_id) {
        request.address.address_id = address.address_id;
    }

    if(homeowner.address_id) {
        request.property_owner_address.address_id = homeowner.address_id;
    }

    return request;
}